// Import model
import { ChatReferenceFieldOptions } from '../models/ChatReferenceFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ChatReferenceFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class ChatReferenceFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a ChatReferenceFieldOptions instance
   */
  static deserialize(json: string): ChatReferenceFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ChatReferenceFieldOptions instance
   */
  static fromObject(obj: any): ChatReferenceFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ChatReferenceFieldOptions');
    }


    const instance: ChatReferenceFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      assistantId: obj['AssistantId'] as string,
      assistantIdName: obj['AssistantId|Name'] as string | undefined,
      objectIdToReference: obj['ObjectIdToReference'] as string | undefined,
      objectTypeToReference: obj['ObjectTypeToReference'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ChatReferenceFieldOptions instances
   */
  static deserializeArray(json: string): ChatReferenceFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ChatReferenceFieldOptions instance to a JSON string
   */
  static serialize(instance: ChatReferenceFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ChatReferenceFieldOptions instance to a plain object
   */
  static toObject(instance: ChatReferenceFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'AssistantId': instance.assistantId,
      'AssistantId|Name': instance.assistantIdName,
      'ObjectIdToReference': instance.objectIdToReference,
      'ObjectTypeToReference': instance.objectTypeToReference,
    };
  }

  /**
   * Serializes an array of ChatReferenceFieldOptions instances to a JSON string
   */
  static serializeArray(instances: ChatReferenceFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
